<div class="flex h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-vat-image-2 bg-cover">
    <div class="shadow-xl">
      <div class="bg-white px-8 py-8 rounded-lg bg-opacity-80 shadow-md">
        <div class="max-w-lg   w-80">

          <div class="flex justify-center pb-4 border-b border-blue-500">
            <svg-icon src="assets/svg/logo.svg" svgClass="h-16"></svg-icon>
          </div>


          <div class="mt-4">
            <h2 class="text-center  text-3xl leading-9 font-thin text-blue-500">
              <span class=" font-bold">  Sign in </span>to your account
            </h2>
          </div>
          <form [formGroup]="form" class="mt-8" (submit)="onSubmit()">
            <input type="hidden" name="remember" value="true" />
            <div class="rounded-md shadow-sm">
              <div>
                <input formControlName="username" autocomplete="on" aria-label="Email address" name="email" type="email" required class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5" placeholder="Email address" />
              </div>
              <div class="-mt-px">
                <input formControlName="password" autocomplete="on" aria-label="Password" name="password" type="password" required class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5" placeholder="Password" />
              </div>
            </div>
            <div class="flex items-center justify-between mt-8">
              <div class="flex items-center">
                <!-- <input id="remember_me" name="remember_me" type="checkbox" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                <label for="remember_me" class="ml-2 block text-sm text-gray-900">
                  Remember me
                </label> -->
              </div>
              <div class="text-xs">
                <a [routerLink]="['../request-reset']" class="font-medium text-blue-600 hover:text-blue-500">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div class="mt-2">
              <button type="submit" [disabled]="form.invalid || loading"
                                    [class.opacity-50]="form.invalid"
                                    [class.hover:bg-yellow-500]="form.valid" class="group relative w-full  flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-secondary focus:outline-none focus:border-yellow-600 focus:shadow-outline-yellow active:bg-yellow-600 transition duration-150 ease-in-out">
                  <svg *ngIf="loading; else notLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <ng-template #notLoading>
                    Sign in
                  </ng-template>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
